function updateButtons() {
    // Get price from the data-product-price attribute
    let priceElement = document.querySelector("[data-product-price]");
    if (!priceElement) return; // Exit if price element is not found

    let priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
    let price = parseFloat(priceText) || 0;

    // Select button elements
    let buyNowButton = document.querySelector(".buy-now-btn");
    let rentItemButton = document.querySelector(".Rent-Item-hide");
    let rentItemButtonNext = document.querySelector(".Rent-Item-hide-next");

    if (price >= 15000) {
        buyNowButton?.classList.add("hide-buy-now");
        rentItemButton?.classList.add("hide-rent-item");
        rentItemButtonNext?.classList.add("hide-rent-item-next");
        priceElement.classList.add("hidden_hide"); // Hide the price
    } else {
        buyNowButton?.classList.remove("hide-buy-now");
        rentItemButton?.classList.remove("hide-rent-item");
        rentItemButtonNext?.classList.remove("hide-rent-item-next");
        priceElement.classList.remove("hidden_show"); // Show the price
    }
}

// Run the function continuously
setInterval(updateButtons, 500);

document.addEventListener("DOMContentLoaded", function () {
  const disabledBtn = document.querySelector(".product-content .product-form .btn--solid.cursor-not-allowed");

  if (disabledBtn) {
    const rentItem = document.querySelector(".Rent-Item.Rent-Item-hide-next");
    if (rentItem) {
      rentItem.classList.add("cursor-not-allowed");
    }
  }
});

